// config/projectCatalog.js
const projectCatalog = {
  "0-2 years": {
    individual: {
      "Software Engineer / Developer": [
        "Online Library Management System",
        "Employee Timesheet Tracker",
        "Blog Platform with Authentication"
      ],
      "Frontend Developer": [
        "Responsive Portfolio Website",
        "E-Commerce Product Listing Page",
        "Interactive Dashboard with Charts"
      ],
      "Backend Developer": [
        "REST API for Student Management",
        "Inventory Management Backend",
        "Order Processing System"
      ],
      "Junior DevOps Engineer": [
        "Dockerized Web Application",
        "CI/CD Pipeline with GitHub Actions",
        "Basic Linux Monitoring Scripts"
      ],
      "QA/Automation Tester": [
        "Automated Login Test Suite",
        "API Testing with Postman Collections",
        "E2E Testing for E-Commerce Checkout"
      ]
    },
    team: {
      "Software Engineer / Developer": [
        "Mini Social Media Platform",
        "Real-Time Chat Application",
        "Online Learning Management System"
      ],
      "Frontend Developer": [
        "Mini Social Media Platform Frontend",
        "Real-Time Chat Application UI",
        "Online Learning Management System Frontend"
      ],
      "Backend Developer": [
        "Enterprise REST API System",
        "Microservices Architecture",
        "Distributed Task Management System"
      ],
      "Junior DevOps Engineer": [
        "Multi-Environment CI/CD Pipeline",
        "Container Orchestration with Kubernetes",
        "Infrastructure as Code with Terraform"
      ],
      "QA/Automation Tester": [
        "Comprehensive Test Automation Suite",
        "API Testing Framework",
        "E2E Testing Platform"
      ]
    }
  },
  "3-6 years": {
    individual: {
      "Full-Stack Engineer": [
        "Social Media Platform (MERN/MEAN Stack)",
        "Real-Time Chat Application",
        "Online Learning Management System"
      ],
      "Cloud Engineer": [
        "Deploy Web App on AWS with Load Balancer",
        "Serverless Image Processing with AWS Lambda",
        "Secure Multi-Tier VPC Setup"
      ],
      "Data Engineer": [
        "ETL Pipeline for Sales Data",
        "Real-Time Kafka Stream Processing",
        "Data Warehouse Integration with Snowflake"
      ],
      "Automation Architect (Junior)": [
        "CI/CD Pipeline with Jenkins & Kubernetes",
        "Automated Deployment on AKS/EKS",
        "IaC with Terraform + GitOps"
      ],
      "AI/ML Engineer": [
        "Customer Churn Prediction Model",
        "Image Classification with CNNs",
        "Movie Recommendation Engine"
      ],
      "Performance Engineer": [
        "Web Application Load Testing (JMeter)",
        "Database Query Optimization",
        "Implement Caching Layer with Redis"
      ]
    },
    team: {
      "Full-Stack Engineer": [
        "Enterprise Social Media Platform",
        "Real-Time Collaboration Tool",
        "Advanced Learning Management System"
      ],
      "Cloud Engineer": [
        "Cloud Platform with Authentication",
        "Cloud-Based E-Commerce Platform",
        "Cloud-Based Healthcare Data Platform"
      ],
      "Data Engineer": [
        "Enterprise Data Pipeline Platform",
        "Real-Time Analytics Dashboard",
        "Data Lake Implementation"
      ],
      "Automation Architect (Junior)": [
        "Enterprise DevOps Platform",
        "Multi-Environment Deployment System",
        "Infrastructure Monitoring Platform"
      ],
      "AI/ML Engineer": [
        "MLOps Platform with Model Registry",
        "Real-Time ML Inference System",
        "AI-Powered Analytics Dashboard"
      ],
      "Performance Engineer": [
        "Performance Testing Platform",
        "Database Optimization Suite",
        "Caching Strategy Implementation"
      ]
    }
  },
  "6-9 years": {
    individual: {
      "Technical Lead": [
        "Enterprise-Scale Microservices Platform",
        "Cross-Team Agile Delivery System",
        "End-to-End Architecture Design for SaaS"
      ],
      "Solution Architect": [
        "Multi-Tenant SaaS Application Design",
        "API Gateway & Microservices Strategy",
        "Hybrid Cloud Integration Architecture"
      ],
      "Senior DevOps / SRE Engineer": [
        "Kubernetes Cluster Setup with Monitoring",
        "Observability Dashboard with Grafana & Prometheus",
        "Disaster Recovery Automation"
      ],
      "AI/ML Specialist": [
        "MLOps Pipeline with Model Registry",
        "RAG (Retrieval-Augmented Generation) Chatbot",
        "LangChain-Powered Document QA System"
      ],
      "Data Architect": [
        "Data Lake Implementation on AWS/GCP",
        "Real-Time Data Streaming with Kafka & Spark",
        "Enterprise Data Modeling with Snowflake"
      ],
      "Security Engineer": [
        "Application Security Testing Automation",
        "Cloud Security Hardening with IAM Policies",
        "Zero Trust Security Model Implementation"
      ]
    },
    team: {
      "Technical Lead": [
        "Enterprise CRM with Analytics",
        "Healthcare Data Pipeline",
        "Banking Fraud Detection System"
      ],
      "Solution Architect": [
        "Enterprise Microservices Platform",
        "Healthcare Data Processing System",
        "Banking Transaction Processing Engine"
      ],
      "Senior DevOps / SRE Engineer": [
        "Enterprise Infrastructure Management",
        "Healthcare Compliance Monitoring System",
        "Banking Security & Compliance Platform"
      ],
      "AI/ML Specialist": [
        "Enterprise AI Platform",
        "Healthcare AI Diagnostics System",
        "Banking AI Risk Assessment Platform"
      ],
      "Data Architect": [
        "Enterprise Data Platform",
        "Healthcare Data Analytics System",
        "Banking Data Warehouse"
      ],
      "Security Engineer": [
        "Enterprise Security Platform",
        "Healthcare Security Compliance System",
        "Banking Security Monitoring Platform"
      ]
    }
  },
  "10-12 years": {
    individual: {
      "Principal Engineer": [
        "Enterprise-Scale Microservices Orchestration",
        "Distributed Event-Driven Order Management System",
        "Scalable Multi-Region SaaS Platform"
      ],
      "Platform Architect": [
        "Service Mesh (Istio/Linkerd) Deployment for Enterprise Apps",
        "Serverless Multi-Cloud Event Processing Pipeline",
        "GitOps Workflow for Continuous Delivery with ArgoCD"
      ],
      "Cloud Solutions Architect": [
        "Cloud-Native Data Processing Platform",
        "Multi-Cloud Disaster Recovery & Failover Strategy",
        "Secure Cloud-Native API Platform with IAM + WAF"
      ],
      "Integration Architect": [
        "Enterprise API Gateway with Event-Driven Integration",
        "Kafka-Based Real-Time Fraud Detection System",
        "Event Sourcing & CQRS for Financial Transactions"
      ],
      "AI/ML Architect": [
        "LLM-Powered Customer Support Chatbot with RAG",
        "Enterprise MLOps Platform for Multi-Model Governance",
        "Scalable AI Inference API with GPU Clusters"
      ],
      "Performance Architect": [
        "Enterprise JVM Performance Optimization Suite",
        "Distributed Caching Strategy with Redis & Hazelcast",
        "High-Throughput Financial Transaction Processing System"
      ]
    },
    team: {
      "Principal Engineer": [
        "Enterprise-Wide Digital Transformation Platform",
        "Global-Scale Healthcare Data Platform",
        "Financial Services Risk Management System"
      ],
      "Platform Architect": [
        "Enterprise Service Mesh Platform",
        "Multi-Cloud Event Processing System",
        "GitOps Enterprise Platform"
      ],
      "Cloud Solutions Architect": [
        "Multi-Cloud Data Platform",
        "Enterprise Disaster Recovery System",
        "Secure API Management Platform"
      ],
      "Integration Architect": [
        "Enterprise Integration Platform",
        "Real-Time Fraud Detection System",
        "Financial Transaction Processing Platform"
      ],
      "AI/ML Architect": [
        "Enterprise AI Platform",
        "MLOps Governance System",
        "AI Inference Platform"
      ],
      "Performance Architect": [
        "Performance Optimization Platform",
        "Distributed Caching System",
        "High-Performance Transaction Platform"
      ]
    }
  },
  "13-15 years": {
    individual: {
      "Enterprise Architect": [
        "Enterprise-Wide Digital Transformation Roadmap",
        "Unified Data Governance & Compliance Architecture",
        "Enterprise Integration with ERP + CRM Systems"
      ],
      "Chief/Principal Solutions Architect": [
        "Multi-Cloud Enterprise SaaS Expansion Strategy",
        "Global-Scale Healthcare Data Sharing Platform",
        "Financial Services Real-Time Risk Management Platform"
      ],
      "SRE/Observability Architect": [
        "Enterprise Chaos Engineering & Resilience Testing",
        "Unified Observability Platform with OpenTelemetry",
        "SLI/SLO Error Budget Governance Framework"
      ],
      "DevSecOps Architect": [
        "Enterprise-Wide Secure CI/CD with Policy Enforcement",
        "Container Image Security & Runtime Protection",
        "Zero-Trust Security Embedded in DevOps"
      ],
      "Big Data Architect": [
        "Real-Time Analytics Platform for Petabyte Data Streams",
        "AI-Augmented Data Lakehouse with Spark & Flink",
        "Multi-Region Streaming Data Platform for IoT Devices"
      ],
      "Innovation Architect": [
        "Edge AI Video Analytics for Smart Cities",
        "Blockchain-Powered Supply Chain Traceability",
        "Quantum Computing PoC for Portfolio Optimization"
      ]
    },
    team: {
      "Enterprise Architect": [
        "Enterprise Digital Transformation Platform",
        "Data Governance & Compliance System",
        "ERP + CRM Integration Platform"
      ],
      "Chief/Principal Solutions Architect": [
        "Multi-Cloud SaaS Platform",
        "Global Healthcare Data Platform",
        "Financial Risk Management System"
      ],
      "SRE/Observability Architect": [
        "Enterprise Observability Platform",
        "Chaos Engineering System",
        "SLO Governance Platform"
      ],
      "DevSecOps Architect": [
        "Secure CI/CD Platform",
        "Container Security System",
        "Zero-Trust DevOps Platform"
      ],
      "Big Data Architect": [
        "Real-Time Analytics Platform",
        "AI Data Lakehouse",
        "IoT Streaming Platform"
      ],
      "Innovation Architect": [
        "Edge AI Platform",
        "Blockchain Supply Chain System",
        "Quantum Computing Platform"
      ]
    }
  },
  "15+ years": {
    individual: {
      "Distinguished Engineer / Technology Fellow": [
        "Enterprise-Wide Reference Architecture for Next-Gen SaaS",
        "Industry Standards Definition for AI/Cloud Interoperability",
        "Open-Source Leadership for Global Developer Ecosystems"
      ],
      "Chief Architect": [
        "Global Cloud Migration Strategy for Fortune 500",
        "AI-Driven Business Process Automation Platform",
        "Next-Gen Data Ecosystem for Real-Time Decisioning"
      ],
      "GenAI Solutions Architect": [
        "Enterprise GenAI Governance & Guardrails Framework",
        "LLM-Powered Knowledge Base for Legal/Compliance",
        "Domain-Specific LLM with Fine-Tuning & Retrieval"
      ],
      "AI Infrastructure Architect": [
        "Enterprise-Scale GPU Cluster Deployment & Scheduling",
        "Low-Latency Inference Pipeline for Generative AI Apps",
        "Hybrid Cloud GPU Resource Orchestration"
      ],
      "Cloud-Native Architect": [
        "Enterprise-Wide Serverless Adoption Strategy",
        "Multi-Cloud Container Orchestration Platform",
        "Service Mesh & Zero-Trust Integration Across Clouds"
      ],
      "Digital Transformation Technical Leader": [
        "Legacy Monolith to Microservices Migration Roadmap",
        "Enterprise-Wide ERP Modernization to SaaS",
        "AI-Enhanced Customer Experience Transformation"
      ]
    },
    team: {
      "Distinguished Engineer / Technology Fellow": [
        "Next-Gen SaaS Reference Platform",
        "AI/Cloud Interoperability Platform",
        "Open-Source Developer Ecosystem"
      ],
      "Chief Architect": [
        "Global Cloud Migration Platform",
        "AI Business Process Platform",
        "Real-Time Decisioning Platform"
      ],
      "GenAI Solutions Architect": [
        "Enterprise GenAI Platform",
        "LLM Knowledge Base System",
        "Domain-Specific LLM Platform"
      ],
      "AI Infrastructure Architect": [
        "GPU Cluster Management Platform",
        "AI Inference Pipeline System",
        "Cloud GPU Orchestration Platform"
      ],
      "Cloud-Native Architect": [
        "Serverless Enterprise Platform",
        "Multi-Cloud Container Platform",
        "Service Mesh Integration Platform"
      ],
      "Digital Transformation Technical Leader": [
        "Microservices Migration Platform",
        "ERP Modernization System",
        "AI Customer Experience Platform"
      ]
    }
  }
};

export default projectCatalog;


